import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { CalendarDays } from 'lucide-react';
import { sessionQueryOptions } from '../../features/auth/auth.queries.ts';
import { DashboardOverview } from '../../features/dashboard/components/DashboardOverview.tsx';
import { GradientCard } from '../../components/layout/GradientCard.tsx';

export const Route = createFileRoute('/_authed/')({
  component: HomeRoute,
});

function getTimeGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Buen día para revisar los contratos de la finca';
  if (hour < 18) return 'Tarde productiva para gestionar su finca';
  return 'Buenas noches, revise los pendientes antes de cerrar';
}

function HomeRoute() {
  const { data: session } = useQuery(sessionQueryOptions);
  const userName = session?.user.name ?? 'Administrador';

  const today = new Date();
  const formattedDate = format(today, "EEEE, d 'de' MMMM 'de' yyyy", { locale: es });
  const currentMonth = format(today, "MMMM yyyy", { locale: es });

  return (
    <div className="flex-1 overflow-auto px-3 sm:px-6 py-4 sm:py-6 mx-auto max-w-7xl w-full">
      {/* Hero greeting */}
      <GradientCard className="mb-6 px-4 sm:px-6 py-4 sm:py-5">
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <h1 className="text-2xl font-semibold capitalize">
              Hola, {userName}.
            </h1>
            <p className="mt-0.5 text-sm text-muted-foreground capitalize">
              {formattedDate}
            </p>
            <p className="mt-1 text-sm text-muted-foreground">
              {getTimeGreeting()}.
            </p>
          </div>
          <div className="flex shrink-0 flex-col items-end gap-0.5 text-right text-xs text-muted-foreground">
            <CalendarDays className="mb-1 size-5 text-primary" aria-hidden />
            <span className="capitalize font-medium">{currentMonth}</span>
          </div>
        </div>
      </GradientCard>

      <DashboardOverview />
    </div>
  );
}
